"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var relationship_filter_html_1 = __importDefault(require("@components/filters/custom-filters/relationship-filter.html"));
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prRelationshipFilterDirectiveLinker', [
        '$q',
        '$timeout',
        'prRelationshipMenuService',
        function ($q, $timeout, relationshipMenuService) {
            var operatorTranslations = {
                in: 'FSFILTERS.IS',
                notIn: 'FSFILTERS.IS_NOT',
                isEmpty: 'FSFILTERS.IS_EMPTY',
                isNotEmpty: 'FSFILTERS.IS_NOT_EMPTY'
            };
            var Linker = function (_$rootScope, _$fcFilter, _$scope) {
                var _this = this;
                this.$rootScope = _$rootScope;
                this.$fcFilter = _$fcFilter;
                this.$scope = _$scope;
                // Initialize the relationship cache
                this.relationshipMapCache = [];
                this.getRelationshipMap();
                this.$scope.template = function () {
                    return relationship_filter_html_1.default;
                };
                var operatorMenu = lodash_1.default.map(operatorTranslations, function (translateKey, value) {
                    return {
                        label: _this.$fcFilter('fcTranslate')(translateKey),
                        value: value
                    };
                });
                $timeout(function () {
                    // timeout is needed to wait for the template scope to be defined
                    _this.$templateScope = _this.$scope.$$childHead;
                    angular_1.extend(_this.$templateScope, {
                        operatorMenu: operatorMenu,
                        onSelection: _this.onSelection.bind(_this),
                        updateFilter: _this.updateFilter.bind(_this),
                        operator: _this.$scope.displayedFilter.filter.operator,
                        isOperandDisabled: _this.isOperandDisabled.bind(_this),
                        getOperatorLabel: _this.getOperatorLabel.bind(_this),
                        getOperandLabel: _this.getOperandLabel.bind(_this),
                        getOperands: _this.getOperands.bind(_this)
                    });
                });
            };
            Linker.prototype.onSelection = function (value, selected) {
                var existingOperands = this.$scope.displayedFilter.filter.operand || [];
                if (selected) {
                    this.updateFilter(existingOperands.concat([value]));
                }
                else {
                    this.updateFilter(lodash_1.default.without(existingOperands, value));
                }
            };
            Linker.prototype.updateFilter = function (keys) {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        $timeout(function () {
                            _this.$scope.displayedFilter.filter.operator = _this.$templateScope.operator;
                            _this.$scope.displayedFilter.filter.operand = _this.isOperandDisabled() ? _this.$templateScope.operator === 'isNotEmpty' : keys;
                            _this.$rootScope.$broadcast('filterChanged');
                        });
                        return [2 /*return*/];
                    });
                });
            };
            Linker.prototype.isOperandDisabled = function () {
                return lodash_1.default.includes(['isEmpty', 'isNotEmpty'], this.$templateScope.operator);
            };
            Linker.prototype.getOperatorLabel = function () {
                var scopeOperator = this.$scope.displayedFilter.filter.operator;
                var operator = operatorTranslations[scopeOperator] || 'FSFILTERS.SELECT_OPERATOR';
                return this.$fcFilter('fcTranslate')(operator);
            };
            /*
             * Get the label for the operand dropdown, based on the number of operands applied.
             */
            Linker.prototype.getOperandLabel = function () {
                var operand = this.$scope.displayedFilter.filter.operand;
                if (!operand || !operand.length) {
                    return this.$fcFilter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
                }
                else if (operand.length > 1) {
                    return operand.length + " " + this.$fcFilter('fcTranslate')('FSFILTERS.SELECTED');
                }
                if (this.relationshipMapCache && this.relationshipMapCache[operand[0]]) {
                    return this.relationshipMapCache[operand[0]].label;
                }
                return operand[0];
            };
            /*
             * Generate operand menu from search string.
             */
            Linker.prototype.getOperands = function (search) {
                return __awaiter(this, void 0, void 0, function () {
                    var operand, menuItems;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                operand = this.$scope.displayedFilter.filter.operand;
                                return [4 /*yield*/, this.getRelationshipMap()];
                            case 1:
                                _a.sent();
                                if (!this.relationshipMapCache || lodash_1.default.isEmpty(this.relationshipMapCache)) {
                                    return [2 /*return*/, [{
                                                label: this.$fcFilter('fcTranslate')('FSFILTERS.NO_AVAILABLE_FIELDS'),
                                                disabled: true
                                            }]];
                                }
                                menuItems = lodash_1.default.map(this.relationshipMapCache, function (relation) {
                                    if (search && search.length > 1) {
                                        search = lodash_1.default.toLower(search);
                                        if (!lodash_1.default.includes(lodash_1.default.toLower(relation.label), search) &&
                                            !lodash_1.default.includes(lodash_1.default.toLower(relation.value), search)) {
                                            return;
                                        }
                                    }
                                    return {
                                        value: relation.value,
                                        label: relation.label,
                                        selected: lodash_1.default.includes(operand, relation.value)
                                    };
                                });
                                return [2 /*return*/, lodash_1.default.compact(menuItems)];
                        }
                    });
                });
            };
            /*
             * Get and format the survey relationships into a map:
             * {
             * 		{id}: {
             * 			value: relationshipId (Q_TS_RS),
             * 			label: relationship label (SubjectRelationshipName)
             * 		}
             * }
             */
            Linker.prototype.getRelationshipMap = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var relationships;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.relationshipMapCache && !lodash_1.default.isEmpty(this.relationshipMapCache)) {
                                    return [2 /*return*/, $q.when(this.relationshipMapCache)];
                                }
                                return [4 /*yield*/, relationshipMenuService.getFormattedRelationships()];
                            case 1:
                                relationships = _a.sent();
                                this.relationshipMapCache = lodash_1.default.keyBy(relationships, 'value');
                                // Trigger a digest cycle to load the labels
                                this.$templateScope.$digest();
                                return [2 /*return*/];
                        }
                    });
                });
            };
            return Linker;
        }
    ]);
})(angular_1.module('qualtrics.pr'));
